var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillIconsFigmaLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6562 0H17.3438C7.76506 0 0 7.55519 0 16.875V55.125C0 64.4448 7.76506 72 17.3438 72H56.6562C66.2349 72 74 64.4448 74 55.125V16.875C74 7.55519 66.2349 0 56.6562 0Z",
    fill: "#F4F2ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_22",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 7,
    width: 40,
    height: 58
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6328 7.875H56.1822V64.125H17.6328V7.875Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2722 64.125C32.5909 64.125 36.9075 59.9251 36.9075 54.7501V45.3749H27.2722C21.9534 45.3749 17.6366 49.5751 17.6366 54.7501C17.6366 59.9251 21.9534 64.125 27.2722 64.125Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6366 36C17.6366 30.825 21.9534 26.6251 27.2722 26.6251H36.9075V45.3749H27.2722C21.9534 45.3749 17.6366 41.175 17.6366 36Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.636 17.2499C17.636 12.0749 21.9529 7.875 27.2716 7.875H36.9069V26.6251H27.2716C21.9529 26.6251 17.636 22.4249 17.636 17.2499Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9075 7.875H46.5428C51.8616 7.875 56.1784 12.0749 56.1784 17.2499C56.1784 22.4249 51.8616 26.6251 46.5428 26.6251H36.9075V7.875Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1784 36C56.1784 41.175 51.8616 45.3749 46.5428 45.3749C41.2241 45.3749 36.9075 41.175 36.9075 36C36.9075 30.825 41.2241 26.6251 46.5428 26.6251C51.8616 26.6251 56.1784 30.825 56.1784 36Z",
    fill: "#1ABCFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillIconsFigmaLight);
export default __webpack_public_path__ + "static/media/skill-icons_figma-light.59b51be5a45fb35eb348829d19e5fefa.svg";
export { ForwardRef as ReactComponent };